import React from 'react';
import '../styles/UserAddresses.css';

function UserAddresses({ addresses }) {
	return (
		<div className="addresses">
			<h2 style={{ margin: 20 }}>Twoje adresy</h2>
			{addresses && addresses.length > 0 ? (
				<ul>
					{addresses.map((address, index) => (
						<li key={index}>
							{address.street}, {address.city}, {address.postalCode}, {address.country}
							{address.isDefault && ' (Domyślny)'}
						</li>
					))}
				</ul>
			) : (
				<p className="no-addresses">Funkcjonalność powstanie wkrótce.</p>
			)}
		</div>
	);
}

export default UserAddresses;
